// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"87":"de921b3e","164":"f6ef2be3"}[chunkId] || chunkId) + "." + {"87":"85a28c169f0dc050","164":"1df0a830168fa140","291":"bbd22397c717188b","438":"6f84606ee889049a","461":"0984050fac458ed3","483":"5e9ffca7a60d5b46","813":"5d278d52c529a914","931":"fbfbe9f8854cf22e"}[chunkId] + ".js";
};